import React from 'react';
import Select from 'components/ui/Select';
import { Calendar, Filter } from 'lucide-react';

const AnalyticsFilters = ({ filters, onFiltersChange }) => {
  const dateRangeOptions = [
    { value: '7', label: '7 derniers jours' },
    { value: '30', label: '30 derniers jours' },
    { value: '90', label: '90 derniers jours' },
    { value: '365', label: '12 derniers mois' }
  ];

  const statusOptions = [
    { value: '', label: 'Tous les statuts' },
    { value: 'active', label: 'Actifs' },
    { value: 'paused', label: 'En pause' },
    { value: 'expired', label: 'Expirés' },
    { value: 'draft', label: 'Brouillons' }
  ];

  const handleFilterChange = (field, value) => {
    onFiltersChange?.({ [field]: value });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div className="flex items-center space-x-2 mb-4">
        <Filter className="h-5 w-5 text-gray-400" />
        <h3 className="text-lg font-medium text-gray-900">Filtres</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Date Range Filter */}
        <div>
          <Select
            label="Période"
            value={filters?.dateRange || '30'}
            onChange={(value) => handleFilterChange('dateRange', value)}
            options={dateRangeOptions}
            icon={Calendar}
          />
        </div>

        {/* Status Filter */}
        <div>
          <Select
            label="Statut des liens"
            value={filters?.status || ''}
            onChange={(value) => handleFilterChange('status', value)}
            options={statusOptions}
          />
        </div>

        {/* Campaign Filter - This would need to be populated with actual campaigns */}
        <div>
          <Select
            label="Campagne"
            value={filters?.campaign || ''}
            onChange={(value) => handleFilterChange('campaign', value)}
            options={[
              { value: '', label: 'Toutes les campagnes' },
              // This would be populated with actual campaign data
            ]}
            disabled
            placeholder="Bientôt disponible"
          />
        </div>
      </div>
      {/* Quick Filter Buttons */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => handleFilterChange('dateRange', '7')}
            className={`px-3 py-1 rounded-full text-sm font-medium border transition-colors ${
              filters?.dateRange === '7' ?'bg-indigo-100 text-indigo-800 border-indigo-200' :'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
            }`}
          >
            Cette semaine
          </button>
          <button
            onClick={() => handleFilterChange('dateRange', '30')}
            className={`px-3 py-1 rounded-full text-sm font-medium border transition-colors ${
              filters?.dateRange === '30' ?'bg-indigo-100 text-indigo-800 border-indigo-200' :'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
            }`}
          >
            Ce mois
          </button>
          <button
            onClick={() => {
              onFiltersChange?.({ 
                dateRange: '30',
                status: 'active',
                campaign: ''
              });
            }}
            className="px-3 py-1 rounded-full text-sm font-medium border bg-white text-gray-600 border-gray-300 hover:bg-gray-50 transition-colors"
          >
            Réinitialiser
          </button>
        </div>
      </div>
      {/* Filter Summary */}
      <div className="mt-3 pt-3 border-t border-gray-200">
        <div className="text-sm text-gray-600">
          Affichage des données pour les{' '}
          <span className="font-medium">
            {dateRangeOptions?.find(opt => opt?.value === filters?.dateRange)?.label || '30 derniers jours'}
          </span>
          {filters?.status && (
            <>
              {' '}avec le statut{' '}
              <span className="font-medium">
                {statusOptions?.find(opt => opt?.value === filters?.status)?.label?.toLowerCase()}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsFilters;